Namespace 'CustomerVisualMode.SharedSessions'

class CustomerVisualMode.SharedSessions.Dashboard extends Backbone.View
  template: JST['backbone/templates/customer_visual_mode/shared_sessions/dashboard']
  className: 'customer-visual-mode-shared-sessions'

  initialize: ({session, sharedSession, accountData, configuredWidgets}) ->
    @session = session
    @sharedSession = sharedSession
    @accountData = accountData
    @isFilterPanelVisible = true
    @resizeButtonView = new Common.ResizeButton({
      onClick: @_toggleFilterPanelVisibility,
      rectangularLayout: true
    })
    factory = new Common.Dashboard.Charts.SessionChartListItemCollectionViewFactory(configuredWidgets)
    @sessionChartsView = new Common.Sessions.SharedSessionChartsView({
      session: session,
      sharedSession: sharedSession,
      chartListItemCollectionViewFactory: factory,
      isReadOnly: true
      isResponsive: true
    })
    @filtersViewHeader ||= new Common.Dashboard.AppliedFiltersHeader()
    @listenTo(@filtersViewHeader, 'filters:hide', => @_setFilterPanelVisibility(true))
    @listenTo(@sharedSession, 'session:execution:pending', => @_toggleLoading(true))
    @listenTo(@sharedSession, 'session:execution', => @_toggleLoading(false))
    @listenTo(@sharedSession, 'session:execution', @_updateFilters)

  render: ->
    @$el.html(@template())
    @renderNavbar()
    @_renderAppliedFilters()
    @_renderSessionCharts()
    @_setFilterPanelVisibility(@isFilterPanelVisible)
    @

  _updateFilters: (response) ->
    filters = response.filters
    compositeFilter = @session.getCompositeFilter()
    compositeFilter.setFilters(filters)
    return unless @_compositeFiltersHasChanged(compositeFilter, @session.getCompositeFilter())
    @session.setCompositeFilter(compositeFilter)
    @_renderAppliedFiltersView()

  _compositeFiltersHasChanged: (newCompositeFilter, currentCompositeFilter) ->
    JSON.stringify(newCompositeFilter.toJSON()) != JSON.stringify(currentCompositeFilter.toJSON())

  _renderAppliedFilters: ->
    @$('.filters-container').append(@filtersViewHeader.render().el)
    @filtersView = new Common.Dashboard.Filters.AppliedFiltersView({
      session: @session
      isReadOnly: true
      filtersFactory: @session.filtersFactory
    })
    @_renderAppliedFiltersView()
    @$('.filters-container').append(@resizeButtonView.render().el)

  _renderAppliedFiltersView: ->
    @filtersView?.remove()
    @$('.filters-container').append(@filtersView.render().el)

  renderNavbar: ->
    @navbarView?.remove()
    @navbarView = new Common.Dashboard.NavbarView({sharedSession: @sharedSession, accountData: @accountData})
    @listenTo(@navbarView, 'filters:show', => @_setFilterPanelVisibility(false))
    @$('#navbar-container').append(@navbarView.render().el)

  _toggleFilterPanelVisibility: =>
    @_setFilterPanelVisibility(!@isFilterPanelVisible)

  _setFilterPanelVisibility: (isVisible) ->
    @isFilterPanelVisible = isVisible
    @$el.toggleClass('filters-closed', isVisible)

  _renderSessionCharts: ->
    @$('.charts-container').empty().append(@sessionChartsView.render().el)

  _toggleLoading: (loading) =>
    @$el.toggleClass('customer-visual-mode-loading', loading)
